import type {TemplateGroup} from '../../templates/template-groups/types';

import type {EmailComposerFormSequenceState} from '../types';

export const wasPreviouslyMaterialized = (sequence: EmailComposerFormSequenceState) => {
    return sequence && sequence.isMaterialized;
};

export const getGroupSequenceTemplates = (groups: TemplateGroup[]) =>
    groups.reduce<Array<any>>((accum, group: TemplateGroup) => {
        accum.push(...group.emailSequenceTemplates);

        return accum;
    }, []);
